import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"

// DayPicker default styles (required for proper rendering)
import "react-day-picker/dist/style.css"

import { cn } from "../../lib/utils"

const ACCENT_COLOR = "#285A82"

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3 text-sm text-[#0B1220]", className)}
      style={{
        "--rdp-accent-color": ACCENT_COLOR,
        "--rdp-accent-color-dark": ACCENT_COLOR,
        "--rdp-background-color": "rgba(40, 90, 130, 0.12)",
        "--rdp-outline": "2px solid rgba(40, 90, 130, 0.35)",
        "--rdp-outline-selected": "2px solid rgba(40, 90, 130, 0.55)",
        "--rdp-selected-color": "#ffffff",
      }}
      classNames={{
        months:
          "flex flex-col gap-4 sm:flex-row sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "relative flex items-center justify-center pt-1",
        caption_label: "text-base font-semibold text-[#0B1220]",
        nav: "absolute right-1 flex items-center gap-1",
        nav_button:
          "inline-flex h-7 w-7 items-center justify-center rounded-full border border-[#d7e2ef] text-[#0B1220] transition-colors hover:bg-[#e9f2fb] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#285A82]/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white",
        nav_button_previous: "",
        nav_button_next: "",
        table: "w-full border-collapse",
        head_row: "flex",
        head_cell:
          "w-9 text-center text-[0.7rem] font-semibold uppercase tracking-wide text-[#3f546e]",
        row: "mt-2 flex w-full",
        cell: "relative h-9 w-9 p-0 text-center text-sm",
        day: cn(
          "inline-flex h-9 w-9 items-center justify-center rounded-md font-medium transition-colors",
          "hover:bg-[#e9f2fb] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#285A82]/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
        ),
        day_selected: cn(
          "bg-[#285A82] text-white",
          "hover:bg-[#3F7BA7] hover:text-white focus:bg-[#285A82] focus:text-white"
        ),
        day_today: "border border-[#285A82]/40",
        day_outside: "text-[#94a6bc]",
        day_disabled: "text-[#bdc8d6] opacity-70",
        day_hidden: "invisible",
        ...classNames,
      }}
      components={{
        IconLeft: ({ className, ...props }) => (
          <ChevronLeft className={cn("h-4 w-4", className)} {...props} />
        ),
        IconRight: ({ className, ...props }) => (
          <ChevronRight className={cn("h-4 w-4", className)} {...props} />
        ),
      }}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar"

export { Calendar }
